// removed by extract-text-webpack-plugin
module.exports = {"getting-started-page":"getting-started-page","page-title":"page-title","intro-box":"intro-box","lead":"lead","step-card":"step-card","step-header":"step-header","step-number":"step-number","step-title":"step-title","step-badge":"step-badge","recommended":"recommended","advanced":"advanced","step-content":"step-content","step-details":"step-details","content-box":"content-box","alert":"alert","alert-info":"alert-info","training-video-card":"training-video-card","video-thumbnail":"video-thumbnail","play-button":"play-button","video-content":"video-content"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/GettingStarted/GettingStarted.scss
// module id = 5567
// module chunks = 1